export interface EDQuestion {
  uid: number;
  curriculumUID: number; // 상위 커리쿨럼 UID
  displayOrder: number; // 표시 순서
  question: string; // 문항
  answer1: string; // 보기 1
  answer2: string; // 보기 2
  answer3: string; // 보기 3
  answer4: string; // 보기 4
  rightness: number; // 정답 번호 - 1부터 시작 - 1 2 3 4중 하나
  isDeleted: boolean;

  // NOT DB
  wrongPercent: string;
}

export interface QuestionListParams {
  token: string;
  id: number; // 상위 커리쿨럼 UID
}

export const initializeQuestion: EDQuestion = {
  uid: 0,
  curriculumUID: 0, // 상위 개체 UID
  displayOrder: 0, // 표시 순서
  question: "", // 문항
  answer1: "", // 보기 1
  answer2: "", // 보기 2
  answer3: "", // 보기 3
  answer4: "", // 보기 4
  rightness: 1, // 정답 번호 - 1부터 시작 - 1 2 3 4중 하나
  isDeleted: false,
  wrongPercent: "",
};
